/**
 * モバイルOSの取得
 * Note: iOS13以降のiPadでは、UserAgentが適切に取得できなくなっているため、適切に取得できる方法でiPadの条件分岐を追加している
 * 参考：https://qiita.com/ShingoFukuyama/items/ef573a8e3e23ef12542e
 *      https://junpei-sugiyama.com/ipad-useragent/
 */
export const getMobileOS = () => {
  const ua = navigator.userAgent;
  if (/android/i.test(ua)) {
    return "Android";
  } else if (/iPhone|iPod/.test(ua)) {
    return "iPhone";
  } else if (/Macintosh/.test(ua) && "ontouchend" in document) {
    return "iPad";
  } else {
    return "Other";
  }
};

/**
 * 現在利用している環境がモバイルOSではない状態を取得
 */
// HACK: 関数名と返却値の意味が一致しないので、関数名を再検討
export const getMobileTerminal = () => {
  const os = getMobileOS();
  return os !== "iPhone" && os !== "iPad" && os !== "Android";
};
